module.exports = __webpack_public_path__ + "static/media/file.22e397d3.svg";